import { createStore, select, withProps } from '@ngneat/elf';
import { Role } from '@tmx/data-access';
import { Subject, map, shareReplay } from 'rxjs';

interface AppProps {
  userRoles: Role[];
  isOriginalLogin: boolean;
  brazeInitialized: boolean;
}

const appStore = createStore(
  { name: 'app' },
  withProps<AppProps>({
    userRoles: [],
    isOriginalLogin: true,
    brazeInitialized: false,
  })
);

/** Snapshots */

export const appStoreSnapshot = () => appStore.getValue();
export const isViewingChildAccount = () => !appStore.getValue().isOriginalLogin;

/** Exposed Variables and Observables */

export const isViewingChildAccount$ = appStore.pipe(
  select(({ isOriginalLogin }) => !isOriginalLogin)
);

export const userRoles$ = appStore.pipe(select(({ userRoles }) => userRoles));

export const hasAlkRole$ = appStore.pipe(
  select(({ userRoles }) => userRoles),
  map((roles) =>
    roles.some((role) => role === 'ALK Administrator' || role === 'ALK Support')
  )
);

export const brazeInitialized$ = appStore.pipe(
  select(({ brazeInitialized }) => brazeInitialized),
  shareReplay({ bufferSize: 1, refCount: true })
);

export const userAuthenticated$ = new Subject<void>();
export const userLoggedOut$ = new Subject<void>();
export const userSwitchingAccounts$ = new Subject<void>();

/** Updater Functions */

export function updateUserRoles(userRoles: Role[]) {
  appStore.update((state) => ({
    ...state,
    userRoles,
  }));
}

export function updateIsOriginalLogin(isOriginalLogin: boolean) {
  appStore.update((state) => ({
    ...state,
    isOriginalLogin,
  }));
}

export function updateBrazeInitialized(brazeInitialized: boolean) {
  appStore.update((state) => ({
    ...state,
    brazeInitialized,
  }));
}

export function resetAppStore() {
  appStore.reset();
}
